import React from 'react';
import s from './MainDescription.module.css';
import Ribbon from '../../Ribbon/Ribbon';

function MainDescription({
  mainHeader,
  mainTextOne,
  mainTextTwo,
  mainTextThird,
  mainTextFourth,
  mainTextFifth,
  mainTextSixth,
}) {
  return (
    <section className={s.section}>
      <div className={s.div}>
        <ul>
          {mainHeader.map(el => {
            return (
              <li key={el}>
                <h2 className={s.header}>{el}</h2>
              </li>
            );
          })}
        </ul>

        <ul className={s.list}>
          <li>{mainTextOne}</li>
          <li>{mainTextTwo}</li>
          {mainTextThird && <li>{mainTextThird}</li>}
          {mainTextFourth && <li>{mainTextFourth}</li>}
          {mainTextFifth && <li>{mainTextFifth}</li>}
          {mainTextSixth && <li>{mainTextSixth}</li>}
        </ul>
      </div>
      <div className={s.ribbon}>
        <Ribbon />
      </div>
    </section>
  );
}

export default MainDescription;
